import { createStore } from "zustand";

import type { FeatureIslandCategoryStoreType } from "./category";
import type { StoreApi } from "zustand";

export type FeatureIslandCategoryManagerStoreType = {
	activeCategoryID: string;
	setActiveCategoryID: (activeCategoryID: string) => void;

	items: StoreApi<FeatureIslandCategoryStoreType>[];

	basicSetupItems: StoreApi<FeatureIslandCategoryStoreType>[];
	nonBasicSetupItems: StoreApi<FeatureIslandCategoryStoreType>[];
};

export type FeatureIslandCategoryManagerStore = ReturnType<typeof createFeatureIslandCategoryManagerStore>;

export const createFeatureIslandCategoryManagerStore = ({
	items,
}: {
	items: StoreApi<FeatureIslandCategoryStoreType>[];
}) => {
	return createStore<FeatureIslandCategoryManagerStoreType>((set) => ({
		activeCategoryID: items[0].getState().categoryID,
		setActiveCategoryID: (activeCategoryID: string) => {
			set({
				activeCategoryID,
			});
		},

		items,
		basicSetupItems: items.filter((item) => item.getState().isBasicSetup),
		nonBasicSetupItems: items.filter((item) => !item.getState().isBasicSetup),
	}));
};
